<template>
  <div class="request--last">
    <p class="text__center text__bold">Last Incomplete Request</p>
    <div v-if="showRequest" class="request--last-data">
      <p class="flex__between">
        <span class="text__bold">Name:</span>
        <span class="data--overflow">{{ request.name }}</span>
      </p>
      <p class="flex__between">
        <span class="text__bold">Submitted:</span>
        <span class="data--overflow">{{ dateClean(request.createdAt) }}</span>
      </p>
      <p class="flex__between">
        <span class="text__bold">Status:</span>
        <span>{{ request.status }}</span>
      </p>
      <p class="flex__center">
        <router-link class="btn link__none" :to="`/${url}/${request._id}`">View Request</router-link>
      </p>
    </div>
    <div v-else class="request--last-empty">
      <p>All requests are completed!</p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["request", "url"],
  computed: {
    showRequest() {
      return this.request ? true : false;
    }
  },
  methods: {
    dateClean(date) {
      return moment(date).format("MM-DD-YYYY");
    }
  }
};
</script>

<style scoped lang="scss">
</style>